module.exports = __webpack_public_path__ + "static/media/en.94cb9756.svg";